// Render extraction-run drop flags (zero-drop invariant) as plain
// sentences for the post-extraction notice. Pure — unit-tested.

import type { ExtractionDropFlag } from "../types";

export function describeDropFlag(f: ExtractionDropFlag): string {
  const name = f.subject?.trim() || f.record_id;
  switch (f.reason) {
    case "dropped_to_zero":
      return `"${name}" had ${f.before} fact${f.before === 1 ? "" : "s"} and now has 0 — re-extract this record.`;
    case "large_drop":
      return `"${name}" dropped from ${f.before} to ${f.after} facts.`;
    case "empty_response_preserved":
      return `"${name}": the model returned no facts; the previous ${f.before} fact${f.before === 1 ? "" : "s"} were kept.`;
  }
}

export function describeDropFlags(flags: ExtractionDropFlag[]): string | null {
  if (flags.length === 0) return null;
  return `⚠ ${flags.length} record${flags.length === 1 ? "" : "s"} flagged by the extraction check: ${flags
    .map(describeDropFlag)
    .join(" ")}`;
}
